import { CountryCode } from 'libphonenumber-js';

import { useCountries } from '../useCountries';

const postalLabel = {
    POSTCODE: 'Postcode',
    ZIPCODE: 'ZIP Code',
    EIRCODE: 'Eircode',
    PIN: 'PIN Code',
};

const useCountryHelpers = () => {
    const { countryConfig } = useCountries();
    const REGION = (process.env.REGION as CountryCode) ?? 'IE';

    const getCountryName = (alpha2code?: string) => {
        switch (alpha2code) {
            case 'XI':
            case 'GB':
                return countryConfig.GB?.name;

            default:
                return countryConfig.IE?.name;
        }
    };

    const getPostalLabel = (countryCode?: string) => {
        const code = countryCode ?? REGION;
        const config = countryConfig[code];
        return !config ? 'Postcode' : postalLabel[config.postalCodeType];
    };

    const normalizeNorthernIrelandName = (name: string) => {
        return name === 'Northern Ireland' ? 'United Kingdom' : name;
    };

    return {
        getCountryName,
        getPostalLabel,
        normalizeNorthernIrelandName
    };
};

export default useCountryHelpers;
